import { TEMPLATES } from '../../../constants/room-layouts.constants';

interface LayoutTemplatesProps {
  onAdd: (template: any) => void;
}

export function LayoutTemplates({ onAdd }: LayoutTemplatesProps) {
  return (
    <div
      style={{
        padding: '1rem',
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        border: '1px solid #bae6fd',
        borderRadius: '12px',
        marginBottom: '1.5rem',
      }}
    >
      <h4 style={{ fontSize: '0.9rem', fontWeight: 600, color: '#075985', marginBottom: '0.75rem' }}>
        Templates suggérés
      </h4>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '0.5rem' }}>
        {TEMPLATES.map((template, index) => (
          <button
            key={index}
            type="button"
            onClick={() => onAdd(template)}
            style={{
              padding: '0.75rem',
              background: 'white',
              border: '1px solid #cbd5e1',
              borderRadius: '8px',
              cursor: 'pointer',
              textAlign: 'left',
              fontSize: '0.85rem',
              fontWeight: 500,
              color: '#00303c',
              transition: 'all 0.2s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#00758d';
              e.currentTarget.style.background = '#f0f9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#cbd5e1';
              e.currentTarget.style.background = 'white';
            }}
          >
            + {template.name}
          </button>
        ))}
      </div>
    </div>
  );
}
